/* istanbul ignore file */

import { LicenseTier } from '../../../models';

export class LicenseTiersServiceModel {
    availableTiers: LicenseTier[] = [];
    isRequestPending = false;
    isRequestSuccessful = false;
}
